module.exports = __webpack_public_path__ + "img/exclusive.1f844d1.jpg";